import { render, staticRenderFns } from "./BookingStatistic.vue?vue&type=template&id=083494e4"
import script from "./BookingStatistic.vue?vue&type=script&lang=js"
export * from "./BookingStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports